import { asReviewRow, type RowInput } from "./reviewRow.types";

export function fieldLabelOf(rows: RowInput[]): (id: string) => string {
  const labels = new Map(
    rows.map((input) => {
      const row = asReviewRow(input);
      return [String(row.id), String(row.sourceAttribute ?? row.id)];
    }),
  );
  return (id) => labels.get(id) ?? id;
}
